// useFetchCampaigns.js
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchCampaigns = (groupId) => {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        let isMounted = true;

        const populateCampaignsData = async () => {
            if (!groupId) {
                setCampaigns([]);
                setLoading(false);
                setError("");
                return;
            }

            setLoading(true);
            setError("");

            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/campaigns/${groupId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    if (isMounted) {
                        setCampaigns(Array.isArray(data) ? data : []);
                    }
                } else {
                    const message = `Failed to fetch campaigns: ${response.status} ${response.statusText}`;
                    console.error('Failed to fetch campaigns:', response.statusText);
                    if (isMounted) {
                        setCampaigns([]);
                        setError(message);
                    }
                }
            } catch (error) {
                console.error('Error fetching campaigns:', error.message);
                if (isMounted) {
                    setCampaigns([]);
                    setError(error.message || "Unable to load campaigns.");
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };
        populateCampaignsData();

        return () => {
            isMounted = false;
        };
    }, [apiUrl, getAccessTokenSilently, groupId, refreshKey]);

    return { campaigns, loading, error, refresh: () => setRefreshKey((value) => value + 1) };
};
